// import {
//   Code,
//   FileText,
//   MessageSquare,
//   Database,
//   CheckCircle,
//   ArrowRight,
//   Zap,
//   Shield,
// } from "lucide-react";

// export default function NLPLLMDatasetServices() {
//   const nlpDatasets = [
//     {
//       icon: FileText,
//       title: "Text Corpus Creation",
//       description:
//         "Large-scale domain-specific and general-purpose corpora for comprehensive language understanding.",
//     },
//     {
//       icon: MessageSquare,
//       title: "Entity Labeling (NER)",
//       description:
//         "Human-labeled named entities for structured text analysis and information extraction.",
//     },
//     {
//       icon: Code,
//       title: "Sentiment & Emotion Annotation",
//       description:
//         "Fine-grained polarity, tone, emotion and intent labels for nuanced analysis.",
//     },
//     {
//       icon: Database,
//       title: "Summarization Data",
//       description:
//         "Extractive and abstractive summary datasets optimized for LLM training.",
//     },
//   ];

//   const llmSets = [
//     "Instruction-Following Datasets",
//     "Conversational & Dialogue Corpora",
//     "Domain-Specific LLM Corpora",
//     "Code & Programming Language Data",
//     "Multi-Turn QA Datasets",
//     "Large Fine-Tuning Collections",
//   ];

//   const benefits = [
//     "Improved model reasoning and coherence",
//     "Higher accuracy on downstream NLP tasks",
//     "Bias reduction with balanced datasets",
//     "Cleaner language representations",
//     "Better domain adaptation",
//     "Stronger multilingual performance",
//   ];

//   const useCases = [
//     "Chatbot and conversational AI",
//     "Search engines & information retrieval",
//     "Sentiment & social media analysis",
//     "Legal, finance, healthcare language models",
//     "Text generation & content automation",
//     "Code generation and debugging LLMs",
//   ];

//   const advancedFeatures = [
//     {
//       title: "Human-in-the-loop annotation",
//       desc: "Expert annotators ensure accuracy and quality at every stage",
//     },
//     {
//       title: "Large-scale multi-domain corpora",
//       desc: "Comprehensive datasets spanning diverse industries and contexts",
//     },
//     {
//       title: "Dataset versioning & metadata tracking",
//       desc: "Full traceability and reproducibility for enterprise needs",
//     },
//     {
//       title: "Multilingual, multi-format datasets",
//       desc: "Support for global applications and diverse data formats",
//     },
//   ];

//   return (
//     <div style={{ backgroundColor: "#ffffff", minHeight: "100vh" }}>
//       {/* Hero Section - Professional */}
//       <section
//         style={{
//           background: `
//       linear-gradient(
//         rgba(0, 0, 0, 0.76),
//         rgba(0, 0, 0, 0.76)
//       ),
//       url('https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1920&q=80')
//     `,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "1280px",
//             margin: "0 auto",
//             padding: "75px 20px", // ⬅️ reduced height (same as others)
//             color: "white",
//           }}
//         >
//           <div style={{ maxWidth: "720px" }}>
//             {/* Badge */}
//             <div
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 marginBottom: "16px",
//                 background: "rgba(59,130,246,0.14)",
//                 border: "1px solid rgba(59,130,246,0.35)",
//                 padding: "8px 14px",
//                 borderRadius: "6px",
//               }}
//             >
//               <span
//                 style={{
//                   color: "#93c5fd",
//                   fontSize: "12px",
//                   fontWeight: 600,
//                   letterSpacing: "1px",
//                 }}
//               >
//                 ENTERPRISE AI LANGUAGE SOLUTIONS
//               </span>
//             </div>

//             {/* Title */}
//             <h1
//               style={{
//                 fontSize: "44px",
//                 fontWeight: "700",
//                 marginBottom: "16px",
//                 lineHeight: "1.15",
//                 letterSpacing: "-0.4px",
//               }}
//             >
//               Professional NLP & LLM Dataset Services
//             </h1>

//             {/* Description */}
//             <p
//               style={{
//                 fontSize: "16px",
//                 color: "#cbd5e1",
//                 marginBottom: "26px",
//                 lineHeight: "1.55",
//                 maxWidth: "600px",
//                 opacity: 0.95,
//               }}
//             >
//               High-quality, ethically sourced linguistic datasets engineered for
//               next-generation AI language models and advanced natural language
//               processing applications with enterprise-grade quality assurance.
//             </p>

//             {/* Actions */}
//             <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
//               <button
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   background: "#3b82f6",
//                   color: "white",
//                   padding: "13px 28px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "14px",
//                   border: "none",
//                   cursor: "pointer",
//                 }}
//               >
//                 Explore Datasets <ArrowRight size={16} />
//               </button>

//               <button
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   background: "transparent",
//                   color: "white",
//                   padding: "13px 28px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "14px",
//                   border: "1.5px solid rgba(255,255,255,0.35)",
//                   cursor: "pointer",
//                 }}
//               >
//                 Request Sample
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Why NLP Datasets Matter */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#f9fafb" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <div style={{ textAlign: "center", marginBottom: "50px" }}>
//             <h2
//               style={{
//                 fontSize: "32px",
//                 fontWeight: "700",
//                 marginBottom: "16px",
//                 color: "#1a202c",
//               }}
//             >
//               Why NLP Datasets Matter
//             </h2>
//             <p
//               style={{
//                 fontSize: "16px",
//                 color: "#64748b",
//                 maxWidth: "800px",
//                 margin: "0 auto",
//                 lineHeight: "1.6",
//               }}
//             >
//               NLP models learn patterns, grammar, reasoning, context, and
//               semantics from high-quality text. The better the dataset, the more
//               intelligent and reliable the model becomes.
//             </p>
//           </div>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//               gap: "24px",
//             }}
//           >
//             {benefits.map((benefit) => (
//               <div
//                 key={benefit}
//                 style={{
//                   display: "flex",
//                   alignItems: "flex-start",
//                   gap: "12px",
//                   padding: "20px",
//                   backgroundColor: "white",
//                   borderRadius: "8px",
//                   boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//                   border: "1px solid #e5e7eb",
//                 }}
//               >
//                 <CheckCircle
//                   size={20}
//                   style={{ color: "#3b82f6", flexShrink: 0, marginTop: "2px" }}
//                 />
//                 <span
//                   style={{
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#1a202c",
//                     lineHeight: "1.6",
//                   }}
//                 >
//                   {benefit}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* NLP Dataset Services */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#ffffff" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <div style={{ marginBottom: "50px" }}>
//             <h2
//               style={{
//                 fontSize: "32px",
//                 fontWeight: "700",
//                 marginBottom: "12px",
//                 color: "#1a202c",
//               }}
//             >
//               NLP Dataset Services
//             </h2>
//             <div
//               style={{
//                 width: "60px",
//                 height: "3px",
//                 background: "#3b82f6",
//                 marginBottom: "16px",
//               }}
//             />
//             <p
//               style={{
//                 color: "#64748b",
//                 fontSize: "16px",
//                 maxWidth: "700px",
//                 lineHeight: "1.6",
//               }}
//             >
//               We build powerful NLP datasets to train models in understanding,
//               analyzing, and generating human-like language.
//             </p>
//           </div>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//               gap: "24px",
//             }}
//           >
//             {nlpDatasets.map((dataset) => {
//               const Icon = dataset.icon;
//               return (
//                 <div
//                   key={dataset.title}
//                   style={{
//                     padding: "28px",
//                     backgroundColor: "#f9fafb",
//                     borderRadius: "8px",
//                     border: "1px solid #e5e7eb",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: "52px",
//                       height: "52px",
//                       background: "#3b82f6",
//                       borderRadius: "8px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       marginBottom: "16px",
//                     }}
//                   >
//                     <Icon size={26} color="white" />
//                   </div>
//                   <h3
//                     style={{
//                       fontSize: "18px",
//                       fontWeight: "700",
//                       marginBottom: "10px",
//                       color: "#1a202c",
//                     }}
//                   >
//                     {dataset.title}
//                   </h3>
//                   <p
//                     style={{
//                       color: "#64748b",
//                       lineHeight: "1.6",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {dataset.description}
//                   </p>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Why LLM Datasets Are Different */}
//       <section
//         style={{
//           padding: "80px 20px",
//           backgroundColor: "#f9fafb",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "1000px",
//             margin: "0 auto",
//             textAlign: "center",
//             padding: "0 20px",
//           }}
//         >
//           <div>
//             <div
//               style={{
//                 width: "72px",
//                 height: "72px",
//                 background: "#3b82f6",
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 margin: "0 auto 24px",
//               }}
//             >
//               <FileText size={36} color="white" />
//             </div>
//             <h2
//               style={{
//                 fontSize: "32px",
//                 fontWeight: "700",
//                 marginBottom: "16px",
//                 color: "#1a202c",
//               }}
//             >
//               Why LLM Datasets Are Different
//             </h2>
//             <p
//               style={{
//                 color: "#64748b",
//                 fontSize: "16px",
//                 lineHeight: "1.6",
//               }}
//             >
//               Unlike standard NLP datasets, LLM training requires massive,
//               diverse, high-quality data across conversational, instructional,
//               factual, and code-based formats. These datasets allow models to
//               reason, follow instructions, write, and converse naturally.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* LLM Training Sets */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#ffffff" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <div style={{ marginBottom: "50px" }}>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 marginBottom: "12px",
//               }}
//             >
//               <div
//                 style={{
//                   width: "52px",
//                   height: "52px",
//                   background: "#3b82f6",
//                   borderRadius: "8px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginRight: "16px",
//                 }}
//               >
//                 <Database size={28} color="white" />
//               </div>
//               <h2
//                 style={{
//                   fontSize: "32px",
//                   fontWeight: "700",
//                   color: "#1a202c",
//                 }}
//               >
//                 LLM Training Sets
//               </h2>
//             </div>
//             <div
//               style={{
//                 width: "60px",
//                 height: "3px",
//                 background: "#3b82f6",
//                 marginBottom: "16px",
//               }}
//             />
//             <p
//               style={{
//                 color: "#64748b",
//                 fontSize: "16px",
//                 maxWidth: "800px",
//                 lineHeight: "1.6",
//               }}
//             >
//               Specialized datasets engineered for training and fine-tuning
//               advanced language models with superior performance.
//             </p>
//           </div>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//               gap: "20px",
//             }}
//           >
//             {llmSets.map((set) => (
//               <div
//                 key={set}
//                 style={{
//                   padding: "20px",
//                   backgroundColor: "#f9fafb",
//                   borderRadius: "8px",
//                   border: "1px solid #e5e7eb",
//                   textAlign: "center",
//                   fontWeight: "600",
//                   fontSize: "15px",
//                   color: "#1a202c",
//                 }}
//               >
//                 {set}
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Advanced Features */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#f9fafb" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <div style={{ textAlign: "center", marginBottom: "50px" }}>
//             <h2
//               style={{
//                 fontSize: "32px",
//                 fontWeight: "700",
//                 marginBottom: "12px",
//                 color: "#1a202c",
//               }}
//             >
//               Advanced Dataset Features
//             </h2>
//             <p style={{ color: "#64748b", fontSize: "16px" }}>
//               Cutting-edge enhancements to improve dataset depth and quality
//             </p>
//           </div>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//               gap: "24px",
//             }}
//           >
//             {advancedFeatures.map((feat) => (
//               <div
//                 key={feat.title}
//                 style={{
//                   padding: "28px",
//                   backgroundColor: "white",
//                   borderRadius: "8px",
//                   boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//                   border: "1px solid #e5e7eb",
//                 }}
//               >
//                 <div
//                   style={{
//                     width: "48px",
//                     height: "48px",
//                     background: "#3b82f6",
//                     borderRadius: "8px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     marginBottom: "16px",
//                   }}
//                 >
//                   <Zap size={24} color="white" />
//                 </div>
//                 <h3
//                   style={{
//                     fontSize: "18px",
//                     fontWeight: "700",
//                     marginBottom: "8px",
//                     color: "#1a202c",
//                   }}
//                 >
//                   {feat.title}
//                 </h3>
//                 <p
//                   style={{
//                     color: "#64748b",
//                     lineHeight: "1.6",
//                     fontSize: "14px",
//                   }}
//                 >
//                   {feat.desc}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Use Cases */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#ffffff" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <div style={{ marginBottom: "50px" }}>
//             <h2
//               style={{
//                 fontSize: "32px",
//                 fontWeight: "700",
//                 marginBottom: "12px",
//                 color: "#1a202c",
//               }}
//             >
//               Use Cases
//             </h2>
//             <div
//               style={{
//                 width: "60px",
//                 height: "3px",
//                 background: "#3b82f6",
//               }}
//             />
//           </div>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//               gap: "20px",
//             }}
//           >
//             {useCases.map((useCase) => (
//               <div
//                 key={useCase}
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "12px",
//                   padding: "18px",
//                   backgroundColor: "#f9fafb",
//                   borderRadius: "8px",
//                   border: "1px solid #e5e7eb",
//                 }}
//               >
//                 <Shield size={20} style={{ color: "#3b82f6", flexShrink: 0 }} />
//                 <span
//                   style={{
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#1a202c",
//                   }}
//                 >
//                   {useCase}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section - Professional */}
//       <section
//         style={{
//           background: "#1e293b",
//           padding: "80px 20px",
//           color: "white",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "900px",
//             margin: "0 auto",
//             textAlign: "center",
//             padding: "0 20px",
//           }}
//         >
//           <div>
//             <h2
//               style={{
//                 fontSize: "36px",
//                 fontWeight: "700",
//                 marginBottom: "16px",
//                 letterSpacing: "-0.5px",
//               }}
//             >
//               Ready to Train Your Next Language Model?
//             </h2>
//             <p
//               style={{
//                 fontSize: "16px",
//                 color: "#cbd5e1",
//                 marginBottom: "32px",
//                 lineHeight: "1.6",
//               }}
//             >
//               Get access to high-quality, custom datasets tailored to your
//               specific enterprise requirements with full compliance and quality
//               assurance.
//             </p>
//             <div
//               style={{
//                 display: "flex",
//                 gap: "16px",
//                 justifyContent: "center",
//                 flexWrap: "wrap",
//               }}
//             >
//               <button
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   background: "#3b82f6",
//                   color: "white",
//                   padding: "14px 32px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "15px",
//                   border: "none",
//                   cursor: "pointer",
//                 }}
//               >
//                 Get Custom Datasets <ArrowRight size={18} />
//               </button>
//               <button
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   background: "transparent",
//                   color: "white",
//                   padding: "14px 32px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "15px",
//                   border: "2px solid rgba(255, 255, 255, 0.2)",
//                   cursor: "pointer",
//                 }}
//               >
//                 Schedule Demo
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

import {
  Code2,
  FileText,
  MessageSquare,
  Database,
  CheckCircle2,
  ArrowRight,
  Zap,
  ShieldCheck,
  BrainCircuit,
  Globe2,
  Terminal,
  Cpu,
} from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function NLPLLMDatasetServices() {
  const nlpDatasets = [
    {
      icon: FileText,
      title: "Text Corpus Creation",
      desc: "Large-scale domain-specific and general-purpose corpora for deep language understanding.",
    },
    {
      icon: MessageSquare,
      title: "Entity Labeling (NER)",
      desc: "Expert-labeled named entities for structured text analysis and high-fidelity extraction.",
    },
    {
      icon: Code2,
      title: "Sentiment & Tone",
      desc: "Fine-grained polarity, emotion, and intent labels for nuanced social and market analysis.",
    },
    {
      icon: Database,
      title: "Summarization Data",
      desc: "Extractive and abstractive summary datasets engineered for high-performance LLM training.",
    },
  ];

  return (
    <main className="bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        {/* Subtle Tech Grid overlay */}
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full text-left">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Linguistic Intelligence
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise <span className="text-indigo-400">NLP & LLM</span>{" "}
              Training Systems.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              High-fidelity, ethically sourced linguistic datasets engineered
              for next-generation Large Language Models and advanced Natural
              Language Processing architectures.
            </p>
            <div className="flex gap-3">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg flex items-center gap-2"
              >
                Explore Datasets <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= CORE NLP SERVICES ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16 md:text-left">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Service Standards
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Structured NLP Data Solutions
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {nlpDatasets.map((item, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 rounded-2xl border border-slate-100 bg-white hover:border-indigo-100 hover:shadow-xl transition-all"
              >
                <div className="w-12 h-12 bg-slate-50 flex items-center justify-center rounded-xl text-slate-900 group-hover:bg-indigo-600 group-hover:text-white transition-all mb-6">
                  <item.icon size={24} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-light">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= LLM SPECIALIZATION (DARK BENTO) ================= */}
      <section className="py-16 md:py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8 items-stretch">
            {/* Left Card */}
            <motion.div
              {...fadeUp}
              className="lg:col-span-7 bg-[#0f172a] p-6 sm:p-8 md:p-16 rounded-2xl md:rounded-[2.5rem] text-white relative overflow-hidden flex flex-col justify-center"
            >
              <div className="absolute top-0 right-0 w-40 sm:w-64 h-40 sm:h-64 bg-indigo-500/10 blur-[90px] rounded-full" />

              <div className="relative z-10">
                <BrainCircuit
                  className="text-indigo-400 mb-4 sm:mb-6"
                  size={32}
                />

                <h3 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4 tracking-tight text-white">
                  Instruction-Tuning Mastery
                </h3>

                <p className="text-slate-400 text-sm sm:text-base md:text-lg font-light leading-relaxed mb-6 sm:mb-8">
                  LLM training requires diverse instructional and factual data.
                  We deliver high-quality datasets to help models reason and
                  converse naturally.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                  {[
                    "Multi-Turn QA Sets",
                    "Fine-Tuning Collections",
                    "Dialogue Corpora",
                    "Logic & Reasoning Data",
                  ].map((feat) => (
                    <div
                      key={feat}
                      className="flex items-center gap-3 bg-white/5 p-3 rounded-xl border border-white/10 backdrop-blur-sm"
                    >
                      <CheckCircle2
                        size={16}
                        className="text-indigo-400 shrink-0"
                      />
                      <span className="text-[12px] sm:text-[13px] font-medium text-slate-200">
                        {feat}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>

            {/* Right Card */}
            <motion.div
              {...fadeUp}
              transition={{ delay: 0.2 }}
              className="lg:col-span-5 bg-white p-6 sm:p-8 md:p-10 rounded-2xl md:rounded-[2.5rem] border border-slate-200 shadow-sm flex flex-col justify-center"
            >
              <Terminal className="text-indigo-600 mb-4 sm:mb-6" size={32} />

              <h3 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 sm:mb-4 tracking-tight">
                Code & Logical Data
              </h3>

              <p className="text-slate-500 text-sm sm:text-base font-light leading-relaxed mb-5 sm:mb-6">
                Specialized datasets for programming models, debugging AI, and
                automated content generation.
              </p>

              <div className="space-y-3 sm:space-y-4">
                {[
                  "Python / JS / C++ Corpora",
                  "Bug-Fixing Pairs",
                  "Instruction Following",
                ].map((item) => (
                  <div
                    key={item}
                    className="flex items-center gap-3 text-sm font-semibold text-slate-700"
                  >
                    <div className="w-1.5 h-1.5 rounded-full bg-indigo-600" />
                    {item}
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ================= ADVANCED FEATURES (INDUSTRIAL GRID) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Enterprise Infrastructure
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                icon: Zap,
                t: "Human-in-the-Loop",
                d: "Expert annotators ensure accuracy and quality at every training stage.",
              },
              {
                icon: Globe2,
                t: "Multilingual Support",
                d: "Global datasets spanning 50+ languages with regional adaptation.",
              },
              {
                icon: Database,
                t: "Full Traceability",
                d: "Dataset versioning and metadata tracking for enterprise compliance.",
              },
              {
                icon: ShieldCheck,
                t: "Bias Mitigation",
                d: "Rigorous balancing to ensure neutral and inclusive language models.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:bg-white hover:shadow-md transition-all group text-left"
              >
                <item.icon
                  className="text-indigo-600 mb-4 group-hover:scale-110 transition-transform"
                  size={24}
                />
                <h4 className="font-bold text-slate-900 text-sm mb-2">
                  {item.t}
                </h4>
                <p className="text-xs text-slate-500 leading-relaxed font-light">
                  {item.d}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden border-t border-white/5 text-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight">
            Architect Your AI Future.
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto text-center">
            Need custom corpora for niche industries like Law, Finance, or
            Healthcare? Our expert linguistic teams provide tailored data
            collection with SOC2 compliance.
          </p>
          <div className="flex justify-center gap-4">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-10 py-3 rounded-xl font-bold text-sm hover:bg-indigo-50 transition-all shadow-xl shadow-black/20"
            >
              Initiate Technical Consultation
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}